(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ccpa-section"]) return;
  try {
    
var ccpaSlideUpAll = function() {
        $('#form-ccpa-edit-account-request').slideUp(100);
        $('#form-ccpa-data-account-request').slideUp(100);
        $('#form-ccpa-personal-data-report-request').slideUp(100);
        $('#form-ccpa-delete-account-request').slideUp(100);
        $('#ccpa_page button').attr("aria-expanded", "false");
    };

    var email, type, consentGiven = false;
    var verificationModalContent = '<div id="data-verification-background"><div class="loading"></div><div id="data-verification-modal"><span class="data-verification-close">&times;</span><div id="data-verification-container"><input type="checkbox" style="display: none;"><label id="data-verification-icon"><svg width="18px" height="18px" viewBox="0 0 18 18"><path d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z"></path></path><polyline points="1 9 7 14 15 4"></polyline></svg></label><p>I give my consent on collecting my email and IP address for the purpose of processing this request. For more check <a href="https://gdprcdn.b-cdn.net/pages/privacy_policy"  target="_blank">Privacy Policy</a>.</p></div></div></div>';

    var ccpaSendRequest = function(callback) {
      $.ajax({
        url: 'https://www.cloudflare.com/cdn-cgi/trace',
        method: 'GET',
        success: function(resp) {
          if (!resp.error) {
            let ipInfo = resp;
            let ipRegex = /[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}/
            let ipAddress = ipInfo.match(ipRegex)[0];

            $.ajax({
                url: 'https://gdpr.apps.isenselabs.com/gdprRequests/submitRequest',
                method: 'POST',
                data: {
                    shop: Shopify.shop,
                    email: email,
                    type: type,
                    sourceOfRequest: 2,
                    ipAddress: ipAddress,
                    consentGiven: consentGiven,
                    lang: Shopify.locale ? Shopify.locale : '',
                    gtranslateLang: isenseGDPR.Cookies.get('googtrans') ? isenseGDPR.Cookies.get('googtrans') : ''
                },
                success: function(resp) {
                    if (!resp.error) {
                        ccpaSlideUpAll();
                        alert('Your request has been submitted successfully. Please check your email for more information.');
                    } else {
                        alert(resp.message);
                    }
                    if (typeof callback == 'function') {
                        callback(resp);
                    }
                }
            });
          } else {
              alert(resp.message);
          }
        }
      });
    }

    $(document).ready(function() {
      //Append modal to body, because otherwise it will not stay centered(even if position is fixed)
      $("body").append(verificationModalContent);

      // When the user clicks on <span> (x), close the modal
      $('.data-verification-close:first').on('click', function(e) {
          e.preventDefault();
          closeVerificationModal();
      });

      $('#data-verification-icon, #data-verification-container p').on('click', function(e) {
          e.preventDefault();

          // Detect a href's click, because it is overwritten.
          if($(e.target).is("a")) {
            window.open(e.target.href, '_blank');
            return;
          }

          $('#data-verification-icon').addClass("clicked");
          setTimeout(()=>{
            $("#data-verification-modal").fadeOut();
            $('#data-verification-background .loading').css('display', 'inline-block');
            consentGiven = true;
            ccpaSendRequest(function(resp) {
                consentGiven = false;
                closeVerificationModal();
            });
          }, 400);
      });
    });

    function openVerificationModal(){
      $("#data-verification-modal").css("display", "block")
      $('#data-verification-background').css("display", "block");
    }
    function closeVerificationModal(){
      $('#data-verification-background').fadeOut();
      $('#data-verification-icon').removeClass("clicked");
      $('#data-verification-background .loading').css('display', 'none');
    }

    $('#btn-ccpa-edit-account-request').on('click', function(e) {
        e.preventDefault();
        ccpaSlideUpAll();
        $('#form-ccpa-edit-account-request').slideDown(200);
        $(this).attr("aria-expanded", "true");
    });

    $('#form-ccpa-edit-account-request form input[type=submit]').on('click', function(e) {
        e.preventDefault();
        email = $('#form-ccpa-edit-account-request form input[name=email]').val();
        type = 'customer/edit';
        openVerificationModal();
    });

    $('#btn-ccpa-requests-request, #btn-ccpa-personal-information-request, #btn-ccpa-orders-request').on('click', function(e) {
        e.preventDefault();
        ccpaSlideUpAll();

        type = '';

        switch($(this).attr('id')) {
            case 'btn-ccpa-requests-request':
                type = 'customer/requests';
                break;
            case 'btn-ccpa-personal-information-request':
                type = 'customer/personal_info';
                break;
            case 'btn-ccpa-orders-request':
                type = 'customer/orders';
                break;
        }

        $('#form-ccpa-data-account-request form input[name="request_type"]').val(type);

        $('#form-ccpa-data-account-request').slideDown(200);
        $(this).attr("aria-expanded", "true");
    });

    $('#form-ccpa-data-account-request form input[type=submit]').on('click', function(e) {
        e.preventDefault();
        email = $('#form-ccpa-data-account-request form input[name=email]').val();
        type = $('#form-ccpa-data-account-request form input[name="request_type"]').val();
        openVerificationModal();
    });

    $('#btn-ccpa-personal-data-report-request').on('click', function(e) {
        e.preventDefault();
        ccpaSlideUpAll();
        $('#form-ccpa-personal-data-report-request').slideDown(200);
        $(this).attr("aria-expanded", "true");
    });

    $('#form-ccpa-personal-data-report-request form input[type=submit]').on('click', function(e) {
        e.preventDefault();
        email = $('#form-ccpa-personal-data-report-request form input[name=email]').val();
        type = 'customer/report';
        openVerificationModal();
    });

    $('#btn-ccpa-delete-account-request').on('click', function(e) {
        e.preventDefault();
        ccpaSlideUpAll();
        $('#form-ccpa-delete-account-request').slideDown(200);
        $(this).attr("aria-expanded", "true");
    });

    $('#form-ccpa-delete-account-request form input[type=submit]').on('click', function(e) {
        e.preventDefault();
        email = $('#form-ccpa-delete-account-request form input[name=email]').val();
        type = 'customer/delete';
        openVerificationModal();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gdpr-section"]) return;
  try {
    
var gdprSlideUpAll = function() {
        $('#form-gdpr-edit-account-request').slideUp(100);
        $('#form-gdpr-data-account-request').slideUp(100);
        $('#form-gdpr-personal-data-report-request').slideUp(100);
        $('#form-gdpr-delete-account-request').slideUp(100);
        $('#gdpr_page button').attr("aria-expanded", "false");
    };

    var email, type, consentGiven = false;
    var verificationModalContent = '<div id="data-verification-background"><div class="loading"></div><div id="data-verification-modal"><span class="data-verification-close">&times;</span><div id="data-verification-container"><input type="checkbox" style="display: none;"><label id="data-verification-icon"><svg width="18px" height="18px" viewBox="0 0 18 18"><path d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z"></path></path><polyline points="1 9 7 14 15 4"></polyline></svg></label><p>I give my consent on collecting my email and IP address for the purpose of processing this request. For more check <a href="https://gdprcdn.b-cdn.net/pages/privacy_policy"  target="_blank">Privacy Policy</a>.</p></div></div></div>';

    var gdprSendRequest = function(callback) {
      $.ajax({
        url: 'https://www.cloudflare.com/cdn-cgi/trace',
        method: 'GET',
        success: function(resp) {
          if (!resp.error) {
            let ipInfo = resp;
            let ipRegex = /[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}/
            let ipAddress = ipInfo.match(ipRegex)[0];

            $.ajax({
                url: 'https://gdpr.apps.isenselabs.com/gdprRequests/submitRequest',
                method: 'POST',
                data: {
                    shop: Shopify.shop,
                    email: email,
                    type: type,
                    sourceOfRequest: 1,
                    ipAddress: ipAddress,
                    consentGiven: consentGiven,
                    lang: Shopify.locale ? Shopify.locale : '',
                    gtranslateLang: isenseGDPR.Cookies.get('googtrans') ? isenseGDPR.Cookies.get('googtrans') : ''
                },
                success: function(resp) {
                    if (!resp.error) {
                        gdprSlideUpAll();
                        alert('Your request has been submitted successfully. Please check your email for more information.');
                    } else {
                        alert(resp.message);
                    }
                    if (typeof callback == 'function') {
                        callback(resp);
                    }
                }
            });
          } else {
              alert(resp.message);
          }
        }
      });
    }

    $(document).ready(function() {
      //Append modal to body, because otherwise it will not stay centered(even if position is fixed)
      $("body").append(verificationModalContent);

      // When the user clicks on <span> (x), close the modal
      $('.data-verification-close:first').on('click', function(e) {
          e.preventDefault();
          closeVerificationModal();
      });

      $('#data-verification-icon, #data-verification-container p').on('click', function(e) {
          e.preventDefault();

          // Detect a href's click, because it is overwritten.
          if($(e.target).is("a")) {
            window.open(e.target.href, '_blank');
            return;
          }

          $('#data-verification-icon').addClass("clicked");
          setTimeout(()=>{
            $("#data-verification-modal").fadeOut();
            $('#data-verification-background .loading').css('display', 'inline-block');
            consentGiven = true;
            gdprSendRequest(function(resp) {
                consentGiven = false;
                closeVerificationModal();
            });
          }, 400);
      });
    });

    function openVerificationModal(){
      $("#data-verification-modal").css("display", "block")
      $('#data-verification-background').css("display", "block");
    }
    function closeVerificationModal(){
      $('#data-verification-background').fadeOut();
      $('#data-verification-icon').removeClass("clicked");
      $('#data-verification-background .loading').css('display', 'none');
    }

    $('#btn-gdpr-edit-account-request').on('click', function(e) {
        e.preventDefault();
        gdprSlideUpAll();
        $('#form-gdpr-edit-account-request').slideDown(200);
        $(this).attr("aria-expanded", "true");
    });

    $('#form-gdpr-edit-account-request form input[type=submit]').on('click', function(e) {
        e.preventDefault();
        email = $('#form-gdpr-edit-account-request form input[name=email]').val();
        type = 'customer/edit';
        openVerificationModal();
    });

    $('#btn-gdpr-requests-request, #btn-gdpr-personal-information-request, #btn-gdpr-orders-request').on('click', function(e) {
        e.preventDefault();
        gdprSlideUpAll();

        type = '';

        switch($(this).attr('id')) {
            case 'btn-gdpr-requests-request':
                type = 'customer/requests';
                break;
            case 'btn-gdpr-personal-information-request':
                type = 'customer/personal_info';
                break;
            case 'btn-gdpr-orders-request':
                type = 'customer/orders';
                break;
        }

        $('#form-gdpr-data-account-request form input[name="request_type"]').val(type);

        $('#form-gdpr-data-account-request').slideDown(200);
        $(this).attr("aria-expanded", "true");
    });

    $('#form-gdpr-data-account-request form input[type=submit]').on('click', function(e) {
        e.preventDefault();
        email = $('#form-gdpr-data-account-request form input[name=email]').val();
        type = $('#form-gdpr-data-account-request form input[name="request_type"]').val();
        openVerificationModal();
    });

    $('#btn-gdpr-personal-data-report-request').on('click', function(e) {
        e.preventDefault();
        gdprSlideUpAll();
        $('#form-gdpr-personal-data-report-request').slideDown(200);
        $(this).attr("aria-expanded", "true");
    });

    $('#form-gdpr-personal-data-report-request form input[type=submit]').on('click', function(e) {
        e.preventDefault();
        email = $('#form-gdpr-personal-data-report-request form input[name=email]').val();
        type = 'customer/report';
        openVerificationModal();
    });

    $('#btn-gdpr-delete-account-request').on('click', function(e) {
        e.preventDefault();
        gdprSlideUpAll();
        $('#form-gdpr-delete-account-request').slideDown(200);
        $(this).attr("aria-expanded", "true");
    });

    $('#form-gdpr-delete-account-request form input[type=submit]').on('click', function(e) {
        e.preventDefault();
        email = $('#form-gdpr-delete-account-request form input[name=email]').val();
        type = 'customer/delete';
        openVerificationModal();
    });


  } catch(e) { console.error(e); }
})();
})();
